/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {Kdo dostává týdenní aktualizace ohledně projektu?} goal {Kdo dostává týdenní aktualizace ohledně cílů?} other {Kdo dostává týdenní aktualizace?}}',
  'share-modal.add-as-follower-checkbox-label': 'Přidat jako sledujícího',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Sledující dostávají týdenní aktualizace ohledně projektu v jejich souhrnu.} goal {Sledující dostávají týdenní aktualizace ohledně cíle v jejich souhrnu.} other {Sledující dostávají týdenní aktualizace v jejich souhrnu.}}',
  'share-modal.all-tab-label': 'Všichni',
  'share-modal.contributors-tab-label': 'Přispěvatelé',
  'share-modal.followers-tab-label': 'Sledující',
  'share-modal.followers-title': 'Sledující',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {Tento projekt uvidí každý s přístupem k pracovnímu prostoru.} goal {Tento cíl uvidí každý s přístupem k pracovnímu prostoru.} other {Tuto položku uvidí každý s přístupem k pracovnímu prostoru.}}',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Soukromý projekt} goal {Soukromý cíl} other {}}',
  'share-modal.footer.copy-link-button': 'Kopírovat odkaz',
  'share-modal.footer.copy-link-button.copied-tooltip': 'Zkopírováno',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {Kopírovat odkaz na projekt} goal {Kopírovat odkaz na cíl} other {Kopírovat odkaz na }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Přidat další lidi',
  'share-modal.share-button': 'Sdílet',
  'share-modal.share-title': 'Sdílet',
  'share-modal.user-item.can-edit-label': 'Může upravovat',
  'share-modal.user-picker.placeholder': 'Vyhledat a pozvat lidi',
  'shareModal.followers-empty-state.default-title': 'Chybí klíčové zainteresované osoby?',
  'shareModal.followers-empty-state.goal-cta':
    'Zajistěte, aby ve svých měsíčních souhrnech dostávali poslední aktualizace ohledně vašeho cíle: Přidejte je jako sledující nebo připojte kanál Slack či MS Teams.',
  'shareModal.followers-empty-state.project-cta':
    'Přidejte klíčové týmy a zainteresované osoby jako sledující, abyste je udrželi v obraze. Připojte kanál a sdílejte aktualizace přímo v chatu.',
  'shareModal.followers-empty-state.project-title': 'Oslovte širší publikum přidáním sledujících',
};
